import { Injectable } from '@angular/core';
import { Resource, ResourceParams, ResourceHandler, ResourceAction, ResourceRequestMethod, IResourceMethodPromise } from '@ngx-resource/core';
export interface IAuth {
  accesstoken: string;
  refreshtoken: string;
  mybusiness: any;
  newAccount: boolean;
  user: {
    email: String,
    phone: String,
    mybUID: String,

    language: string,

    salutation: String,
    companyName: String,
    firstname: String,
    insertion: String,
    lastname: String,

    address: {
      streetandnr: String,
      postalcode: String,
      city: String,
      country: String
    },
  };
}

@ResourceParams({
  pathPrefix: '/api/auth'
})
@Injectable()
export class AuthResource extends Resource {

  constructor(handler: ResourceHandler) {
    super(handler);
  }


  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/create'
  })
  login: IResourceMethodPromise<{ username: string, password: string }, IAuth>;

  @ResourceAction({
    method: ResourceRequestMethod.Get,
    path: '/check'
  })
  check: IResourceMethodPromise<null, null>;

  @ResourceAction({
    method: ResourceRequestMethod.Get,
    path: '/invite/{!hash}'
  })
  getInviteData: IResourceMethodPromise<{ hash }, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/invite/{!hash}/refresh'
  })
  resendInvite: IResourceMethodPromise<{ hash }, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/refresh'
  })
  refresh: IResourceMethodPromise<null, null>;

  @ResourceAction({
    path: '/revoke',
    method: ResourceRequestMethod.Delete,
  })
  logout: IResourceMethodPromise<void, void>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/requestResetPassword/{!email}'
  })
  requestResetPassword: IResourceMethodPromise<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/getResetHash/{!email}/{!code}'
  })
  getResetHash: IResourceMethodPromise<any, any>;


  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/resetPassword'
  })
  resetPassword: IResourceMethodPromise<any, any>;
}
